import ConfirmationBox from './CofirmationBox';

export default ConfirmationBox;
